// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__Sloq4","heading":"PageHeader_heading__Yz4xt","ingress":"PageHeader_ingress__ueAOy","subHeading":"PageHeader_subHeading__Xq+s+"};